import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import urlJoin from 'url-join';
import Player from '../Player';
import NextPrevNav from '../NextPrevNav';
import MediaNav from './MediaNav';


const MediaViewer = ({ location, history, baseUrl, media, activeMedia }) => {
  if (activeMedia.type === 'video' && activeMedia.source === 'vimeo') {
    const { slug, width, height, longDescription, metadata: { sourceUrl, sourceId } } = activeMedia;
    const aspectRatio = width && height ? `${width}:${height}` : undefined;
    const mediaUrls = media.length > 1 && media.map((m, idx) => urlJoin(baseUrl, idx + 1 + ''));
    const curUrlIndex = mediaUrls && mediaUrls.indexOf(location.pathname);
    const nextUrl = curUrlIndex !== null && mediaUrls[curUrlIndex + 1];
    const onPlayerEnd = nextUrl ? () => history.push(nextUrl) : () => {};
    return (
      <Fragment>
        <div className="mb-3">
          <Player
            key={slug}
            video={sourceUrl || sourceId}
            slug={slug}
            aspectRatio={aspectRatio}
            onEnd={onPlayerEnd}
          />
        </div>
        <div className="caption" dangerouslySetInnerHTML={{ __html: longDescription }} />
        {mediaUrls ? <NextPrevNav urls={mediaUrls} /> : null}
        {mediaUrls ? <MediaNav gridUrl={baseUrl} itemUrls={mediaUrls} /> : null}
      </Fragment>
    );
  } else if (activeMedia.type === 'image') {
    // TODO
    return null;
  }

  return null;
};

MediaViewer.propTypes = {
  baseUrl: PropTypes.string,
  media: PropTypes.arrayOf(PropTypes.object),
  activeMedia: PropTypes.object.isRequired,
};

export default withRouter(MediaViewer);



// WEBPACK FOOTER //
// ./src/components/TopicTree/MediaViewer.js